import { Action } from "@ngrx/store";
import { IColumnDefinition } from "../../common/models/column-definition";
import { IResizedColumn } from "../../common/models/table";
import { IContext } from "../../context/models/context";
import { DashboardItem } from "../../dashboards/models/dashboard-item";

export const LOAD = '[Tenancy Schedule Table Column Definition] Load';
export const LOAD_ALL = '[Tenancy Schedule Table Column Definition] Load All';
export const LOAD_ALL_COMPLETE = '[Tenancy Schedule Table Column Definition] Load All Complete';
export const LOAD_ALL_ERROR = '[Tenancy Schedule Table Column Definition] Load All Error';
export const LOAD_COMPLETE = '[Tenancy Schedule Table Column Definition] Load Complete';
export const LOAD_ERROR = '[Tenancy Schedule Table Column Definition] Load Error';
export const UPDATE_COLUMNS = '[Tenancy Schedule Table Column Definition] Update Columns';
export const RESET_TO_DEFAULT = '[Tenancy Schedule Table Column Definition] Reset To Defaults';
export const UPDATE_COLUMNS_COMPLETE = '[Tenancy Schedule Table Column Definition] Update Columns Complete';
export const UPDATE_COLUMNS_ERROR = '[Tenancy Schedule Table Column Definition] Update Columns Error';
export const RESIZE_COLUMNS = '[Tenancy Schedule Table Column Definition] Resize Columns';
export const RESIZE_COLUMNS_COMPLETE = '[Tenancy Schedule Table Column Definition] Resize Columns Complete';
export const RESIZE_COLUMNS_ERROR = '[Tenancy Schedule Table Column Definition] Resize Columns Error';
export const REORDER_COLUMNS = '[Tenancy Schedule Table Column Definition] Reorder Columns';
export const REORDER_COLUMNS_COMPLETE = '[Tenancy Schedule Table Column Definition] Reorder Columns Complete';
export const REORDER_COLUMNS_ERROR = '[Tenancy Schedule Table Column Definition] Reorder Columns Error';

export class Load implements Action {
  readonly type = LOAD;
  constructor(public widget: DashboardItem) { }
}

export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor() { }
}

export class LoadAllComplete implements Action {
  readonly type = LOAD_ALL_COMPLETE;
  constructor(public payload: IColumnDefinition[]) { }
}

export class LoadAllError implements Action {
  readonly type = LOAD_ALL_ERROR;
  constructor(public payload: any) { }
}


export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: IColumnDefinition[], public widget: DashboardItem) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any, public widget: DashboardItem) { }
}

export class UpdateColumns implements Action {
  readonly type = UPDATE_COLUMNS;
  constructor(public columnDefinition: IColumnDefinition[], public context: IContext, public widget: DashboardItem) { }
}

export class ResetToDefault implements Action {
  readonly type = RESET_TO_DEFAULT;
  constructor(public context: IContext, public widget: DashboardItem) { }
}

export class UpdateColumnsComplete implements Action {
  readonly type = UPDATE_COLUMNS_COMPLETE;
  constructor(public context: IContext, public widget: DashboardItem) { }
}

export class UpdateColumnsError implements Action {
  readonly type = UPDATE_COLUMNS_ERROR;
  constructor(public payload: any) { }
}

export class ResizeColumns implements Action {
  readonly type = RESIZE_COLUMNS;
  constructor(public payload: IResizedColumn, public widget: DashboardItem) { }
}

export class ResizeColumnsComplete implements Action {
  readonly type = RESIZE_COLUMNS_COMPLETE;
  constructor(public widget: DashboardItem) { }
}

export class ResizeColumnsError implements Action {
  readonly type = RESIZE_COLUMNS_ERROR;
  constructor(public payload: any) { }
}

export class ReorderColumns implements Action {
  readonly type = REORDER_COLUMNS;
  constructor(public payload: string[], public widget: DashboardItem) { }
}

export class ReorderColumnsComplete implements Action {
  readonly type = REORDER_COLUMNS_COMPLETE;
  constructor(public widget: DashboardItem) { }
}

export class ReorderColumnsError implements Action {
  readonly type = REORDER_COLUMNS_ERROR;
  constructor(public payload: any) { }
}


export type Actions =
  Load |
  LoadAll |
  LoadComplete |
  LoadError |
  UpdateColumns |
  ResetToDefault |
  UpdateColumnsComplete |
  UpdateColumnsError |
  ReorderColumns |
  ReorderColumnsComplete |
  ReorderColumnsError |
  ResizeColumns |
  ResizeColumnsComplete |
  ResizeColumnsError |
  LoadAllComplete |
  LoadAllError

